import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import toast from "react-hot-toast";
import { HOST_API_KEY } from '../../config-global';
import { stubFalse } from 'lodash';

export const courseSlice = createSlice({
    name: "courses",
    initialState: {
        courses: [],
        filteredCourse: [],
        loading: false,
        message: "",
        totalCourse: 0,
        currentCourse: {},
        allCourses: []
    },
    reducers: {
        setCourses(state, action) {
            state.courses = action.payload;
        },
        setMessage(state, action) {
            state.message = action.payload;
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setTotalCourse(state, action) {
            state.totalCourse = action.payload;
        },
        setCurrentCourse(state, action) {
            state.currentCourse = action.payload;
        },
        setAllCourses(state, action) {
            state.allCourses = action.payload;
        },
        setFilteredCourses(state, action) {
            state.filteredCourse = action.payload;
        }
    }
})

export const { setCourses, setMessage, setLoading, setTotalCourse, setCurrentCourse, setAllCourses, setFilteredCourses } = courseSlice.actions;
export default courseSlice.reducer;

export const getCourses = (perPage, page, type = false) => async (dispatch) => {
    try {
        const sort = localStorage.getItem('courseSort');
        const result = await axios.get(`/api/course`, { params: { perPage, page, sort, type } });
        dispatch(setCourses(result.data.data));
    } catch (error) {
        console.log(error);
    }
}

export const insertCourse = (course) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const requestOption = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            },
            body: course
        }
        // const result = await axios.post("course", course);
        const result = await fetch(`${HOST_API_KEY}/api/course`, requestOption).then(res => res.json());
        const message = result.message;
        toast.success(message)
        if (result.success) {
            const page = localStorage.getItem('course_page') ? localStorage.getItem('course_page') : 0;
            const perPage = localStorage.getItem('course_Perpage') ? localStorage.getItem('course_Perpage') : 0;
            dispatch(getCourses(perPage, page));
        }

        dispatch(setMessage(message));
        dispatch(setLoading(false))
    } catch (error) {
        console.log(error);

    }
}

export const deleteCourse = (id, university = '') => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const result = await axios.delete(`/api/course/${id}`);
        if (result.data.success) {
            const page = localStorage.getItem('course_page') ? localStorage.getItem('course_page') : 0;
            const perPage = localStorage.getItem('course_Perpage') ? localStorage.getItem('course_Perpage') : 0;
            if(university){
                dispatch(getCoursesByUniversity(university))
            }else{
                dispatch(getCourses(perPage, page));
            }
        }
        toast.success(result.data.message)
        dispatch(setMessage(result.data.message));
        dispatch(setLoading(false))
    } catch (error) {
        console.log(error);

    }
}

export const approveCourse = (id, is_approved, university = '') => async (dispatch) => {
    try {
        setLoading(false);
        const response = await axios.post("/api/course/approve", { id, is_approved });
        toast.success(response.data.message);
        if (response.data.success) {
            const page = localStorage.getItem('course_page') ? localStorage.getItem('course_page') : 0;
            const perPage = localStorage.getItem('course_Perpage') ? localStorage.getItem('course_Perpage') : 0;
            if(university){
                dispatch(getCoursesByUniversity(university))
            }else{
                dispatch(getCourses(perPage, page));
            }
        }
    } catch (error) {

    }
}

export const updateReview = (id, reviews, university = '') => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const result = await axios.post("/api/course/review", { id, reviews });
        if (result.data.success) {
            const page = localStorage.getItem('course_page') ? localStorage.getItem('course_page') : 0;
            const perPage = localStorage.getItem('course_Perpage') ? localStorage.getItem('course_Perpage') : 0;
            if(university){
                dispatch(getCoursesByUniversity(university))
            }else{
                dispatch(getCourses(perPage, page));
            }
        }
        toast.success(result.data.message);
        dispatch(setMessage(result.data.message));
        dispatch(setLoading(false));
    } catch (error) {
        console.log(error);
    }
}

export const getTotalCourse = () => async (dispatch) => {
    try {
        const result = await axios.get('/api/course/totalCount');
        const allCourses = result.data.data
        dispatch(setTotalCourse(allCourses.length));
        dispatch(setAllCourses(allCourses));
    } catch (error) {
        console.log(error);
    }
}

export const getIndividualCourse = (id) => async (dispatch) => {
    try {
        const result = await axios.get(`/api/course/indi/${id}`);
        dispatch(setCurrentCourse(result.data.data))
    } catch (error) {
        console.log(error)
    }
}

export const searchCourseByName = (title = '', university = '') => async (dispatch) => {
    try {
        console.log(title, university, '=-======== 168')
        const result = await axios.get('/api/course/search', { params: { title, university } });
        dispatch(setFilteredCourses(result.data.data));
    } catch (error) {
        console.log(error)
    }
}

export const getCoursesByUniversity = (universityId) => async (dispatch) => {
    try {
        const sort = localStorage.getItem('courseSort');
        const result = await axios.get('/api/course/university', { params: { universityId, sort } });
        dispatch(setCourses(result.data.data))
    } catch (error) {
        console.log(error)
    }
}